<template>
  <div v-if="rows.length || loading" class="waajo-quickreply" ref="quickReplyRoot">
    <button
      type="button"
      class="waajo-quickreply-trigger"
      :class="{ 'is-open': panelOpen }"
      :aria-expanded="panelOpen ? 'true' : 'false'"
      @click.stop="togglePanel"
    >
      <span class="waajo-quickreply-trigger-icon">
        <i class="fa fa-bolt"></i>
      </span>
      <span class="waajo-quickreply-trigger-copy">
        <strong>Balasan Cepat</strong>
        <small v-if="loading">Memuat template...</small>
        <small v-else>{{ rows.length }} template tersedia</small>
      </span>
      <span v-if="rows.length" class="waajo-quickreply-count">{{ rows.length }}</span>
      <i class="fa" :class="panelOpen ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </button>

    <transition name="waajo-qr-fade">
      <div v-if="panelOpen" class="waajo-quickreply-panel" @click.stop>
        <div class="waajo-quickreply-head">
          <div>
            <strong>Balasan Cepat</strong>
            <small>Pilih template untuk dimasukkan ke kolom pesan.</small>
          </div>
          <button
            type="button"
            class="waajo-quickreply-close"
            title="Tutup balasan cepat"
            @click="closePanel"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="waajo-quickreply-search">
          <i class="fa fa-search"></i>
          <input
            ref="quickReplySearch"
            v-model="searchQuery"
            type="text"
            placeholder="Cari template..."
            @keyup.esc="closePanel"
          />
          <button
            v-if="searchQuery"
            type="button"
            class="waajo-quickreply-clear"
            title="Hapus pencarian"
            @click="searchQuery = ''"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="waajo-quickreply-body">
          <div v-if="loading" class="waajo-quickreply-loading">
            <span v-for="n in 4" :key="'qr-skeleton-' + n" class="waajo-qr-skeleton"></span>
          </div>

          <div v-else-if="filteredRows.length === 0" class="waajo-quickreply-empty">
            <i class="fa fa-search"></i>
            <span>Template tidak ditemukan.</span>
          </div>

          <div v-else class="waajo-quickreply-list">
            <div
              v-for="row in filteredRows"
              :key="row.id"
              class="waajo-quickreply-item"
            >
              <button
                type="button"
                class="waajo-quickreply-use"
                :disabled="detailLoadingId === row.id"
                @click="selectTemplate(row)"
              >
                <span class="waajo-quickreply-item-icon">
                  <i class="fa fa-comment-o"></i>
                </span>
                <span class="waajo-quickreply-item-copy">
                  <strong>{{ row.title || "Tanpa judul" }}</strong>
                  <small v-if="getTemplatePreview(row)">{{ getTemplatePreview(row) }}</small>
                </span>
                <i
                  v-if="detailLoadingId === row.id"
                  class="fa fa-spinner fa-spin waajo-quickreply-item-loading"
                ></i>
                <i v-else class="fa fa-plus waajo-quickreply-item-plus"></i>
              </button>
              <button
                type="button"
                class="waajo-quickreply-preview"
                title="Pratinjau dan kirim template"
                @click="previewTemplate(row)"
              >
                <i class="fa fa-eye"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="waajo-quickreply-foot">
          <span><i class="fa fa-pencil"></i> Pesan dapat diedit sebelum dikirim</span>
        </div>
      </div>
    </transition>

    <a
      v-show="false"
      ref="formPreviewQuickReply"
      class="btn add-btn"
      @click="showBroadcast(false)"
      href="#"
      data-toggle="modal"
      data-target="#add_form"
    >
      <i class="fa fa-whatsapp"></i> Edit
    </a>
    <quick-reply-preview
      :textReplyRows="textReplyRows"
      :buttonsRows="buttonsRows"
      :linkRows="linkRows"
    />
  </div>
</template>

<script>
import QuickReplyPreview from "./quickReplyPreview.vue";

export default {
  components: {
    QuickReplyPreview
  },
  data() {
    return {
      defaultDetailTextReply: 10,
      textReplyRows: [],
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish"
        },
        page: 1,
        perPage: 500
      },
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500
      },
      buttonsRows: [],
      linkRows: [],
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      panelOpen: false,
      searchQuery: "",
      detailLoadingId: "",
      serverParams: {
        columnFilters: {
          title: "",
          message: "",
          is_publish: "publish"
        },
        page: 0,
        perPage: 100
      }
    };
  },
  computed: {
    filteredRows() {
      const keyword = String(this.searchQuery || "").trim().toLowerCase();
      if (!keyword) {
        return this.rows;
      }
      return this.rows.filter(row => {
        return (
          String(row.title || "").toLowerCase().indexOf(keyword) !== -1 ||
          String(row.message || "").toLowerCase().indexOf(keyword) !== -1 ||
          String(row.preview || "").toLowerCase().indexOf(keyword) !== -1
        );
      });
    }
  },
  created() {
    this.loadItems();
    this.loadTextReply();
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keydown", this.handleDocumentKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keydown", this.handleDocumentKeydown);
  },
  methods: {
    togglePanel() {
      this.panelOpen = !this.panelOpen;
      if (this.panelOpen) {
        this.$nextTick(() => {
          if (this.$refs.quickReplySearch) {
            this.$refs.quickReplySearch.focus();
          }
        });
      }
    },
    closePanel() {
      this.panelOpen = false;
      this.searchQuery = "";
    },
    handleDocumentClick(event) {
      if (!this.panelOpen) {
        return;
      }
      const root = this.$refs.quickReplyRoot;
      if (root && !root.contains(event.target)) {
        this.closePanel();
      }
    },
    handleDocumentKeydown(event) {
      if (event.key === "Escape" && this.panelOpen) {
        this.closePanel();
      }
    },
    getTemplatePreview(row) {
      const text = String(row.message || row.preview || "").replace(/\s+/g, " ").trim();
      if (!text) {
        return "";
      }
      return text.length > 110 ? text.slice(0, 110) + "..." : text;
    },
    async selectTemplate(row) {
      if (this.detailLoadingId) {
        return;
      }

      this.detailLoadingId = row.id;
      try {
        const response = await this.$store.dispatch(
          "automation/detailQuickReplyForEdit",
          { id: row.id }
        );
        const data = response && response.data ? response.data : {};
        const header = data.header || {};
        let text = String(header.message || "").trim();
        if (header.footer_message_status === true && header.footer_message) {
          text += (text ? "\n\n" : "") + String(header.footer_message).trim();
        }
        if (!text) {
          text = String(row.title || "").trim();
        }

        this.$emit("select", {
          text,
          title: row.title,
          template: data,
          row
        });
        this.closePanel();
      } catch (error) {
        this.$emit("quick-reply-error", {
          message: "Template gagal dimuat. Silakan coba lagi.",
          error,
          row
        });
      } finally {
        this.detailLoadingId = "";
      }
    },
    async previewTemplate(row) {
      this.closePanel();
      await this.detailData(row.id);
    },
    async loadTextReply() {
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams)
        .then(response => {
          const { data } = response;
          this.textReplyRows = data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams)
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async loadReplyLink() {
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams)
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("automation/setIsShowForm", false);
        this.selectedLicense = [];

        let formData = {
          header: {
            id: "",
            license_id: "",
            message: "",
            footer_message: "",
            footer_message_status: false
          },
          detail_button: [],
          detail_button_away: []
        };
        while (formData.detail_button.length < 10) {
          formData.detail_button.push({ auto_reply_button_id: "" });
        }
        while (formData.detail_button_away.length < 3) {
          formData.detail_button_away.push({ auto_reply_button_id: "" });
        }
        this.$store.dispatch("automation/actFormParamQRSt", formData);
      }
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        if (isShowModal == true) {
          that.$store.dispatch("automation/setIsShowForm", true);
        }
      }, 1000);
    },
    async detailData(id) {
      this.loading = await true;
      this.$store.dispatch("automation/setIsShowForm", false);

      let formData = await {};
      await this.$store
        .dispatch("automation/detailQuickReplyForEdit", { id: id })
        .then(response => {
          var { data } = response;
          data.header.is_custom_url = false;
          data.header.is_enable_attach_file = false;
          if (data.header.image_url != "") {
            data.header.is_enable_attach_file = true;
          }
          formData = data;
          this.loading = false;
        });
      await this.$store.dispatch("automation/actFormParamQRSt", formData);
      var elem = this.$refs.formPreviewQuickReply;
      if (elem) {
        elem.click();
      }
    },
    async loadItems() {
      this.loading = true;

      await this.$store
        .dispatch("automation/listQuickReply", this.serverParams)
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data || [];
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    }
  },
  name: "quickreply-list"
};
</script>

<style scoped>
.waajo-quickreply {
  position: relative;
  width: 100%;
}

.waajo-quickreply-trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  padding: 6px 9px;
  color: #8f5600;
  background: #fffaf1;
  border: 1px solid #f6e3bd;
  border-radius: 9px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.waajo-quickreply-trigger:hover,
.waajo-quickreply-trigger.is-open {
  background: #fff3df;
  border-color: #f6d49b;
}

.waajo-quickreply-trigger-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  color: #ffffff;
  background: #f39c12;
  border-radius: 7px;
  font-size: 10px;
}

.waajo-quickreply-trigger-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

.waajo-quickreply-trigger-copy strong {
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.waajo-quickreply-trigger-copy small {
  overflow: hidden;
  max-width: 180px;
  color: #98a2b3;
  font-size: 8px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-quickreply-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  color: #b36b00;
  background: #ffe7bd;
  border-radius: 20px;
  font-size: 8px;
  font-weight: 700;
}

.waajo-quickreply-trigger > .fa {
  color: #c99a55;
  font-size: 9px;
}

.waajo-quickreply-panel {
  position: absolute;
  bottom: calc(100% + 9px);
  left: 0;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  width: 560px;
  max-width: calc(100vw - 28px);
  max-height: 58vh;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e4ebf3;
  border-radius: 14px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.16);
}

.waajo-quickreply-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 13px 9px;
  border-bottom: 1px solid #eef2f7;
}

.waajo-quickreply-head strong {
  display: block;
  color: #101828;
  font-size: 12px;
}

.waajo-quickreply-head small {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 9px;
}

.waajo-quickreply-close,
.waajo-quickreply-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  padding: 0;
  color: #98a2b3;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-size: 11px;
  cursor: pointer;
}

.waajo-quickreply-close:hover,
.waajo-quickreply-clear:hover {
  color: #b42318;
  background: #fff1f0;
}

.waajo-quickreply-search {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 9px 12px;
  padding: 0 9px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 8px;
}

.waajo-quickreply-search > .fa {
  color: #98a2b3;
  font-size: 10px;
}

.waajo-quickreply-search input {
  flex: 1;
  min-width: 0;
  height: 31px;
  color: #344054;
  background: transparent;
  border: 0;
  outline: 0;
  font-family: inherit;
  font-size: 10px;
}

.waajo-quickreply-body {
  min-height: 60px;
  overflow-y: auto;
  padding: 0 8px 7px;
}

.waajo-quickreply-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.waajo-quickreply-item {
  display: flex;
  align-items: stretch;
  gap: 4px;
  padding: 2px;
  border-radius: 9px;
}

.waajo-quickreply-item:hover {
  background: #fffaf1;
}

.waajo-quickreply-use {
  display: flex;
  flex: 1;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  padding: 7px;
  color: #344054;
  background: transparent;
  border: 0;
  border-radius: 7px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.waajo-quickreply-use:disabled {
  cursor: wait;
  opacity: 0.7;
}

.waajo-quickreply-item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
  height: 25px;
  color: #b36b00;
  background: #fff7e8;
  border-radius: 7px;
  font-size: 10px;
}

.waajo-quickreply-item-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.waajo-quickreply-item-copy strong {
  color: #344054;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.waajo-quickreply-item-copy small {
  color: #98a2b3;
  font-size: 9px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.waajo-quickreply-item-plus,
.waajo-quickreply-item-loading {
  flex: 0 0 auto;
  margin-top: 4px;
  color: #c99a55;
  font-size: 9px;
}

.waajo-quickreply-preview {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 29px;
  width: 29px;
  min-height: 35px;
  color: #98a2b3;
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 7px;
  font-size: 10px;
  cursor: pointer;
}

.waajo-quickreply-preview:hover {
  color: #b36b00;
  border-color: #f6d49b;
}

.waajo-quickreply-loading {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px;
}

.waajo-qr-skeleton {
  display: block;
  height: 34px;
  background: linear-gradient(90deg, #f4f7fb 25%, #eef3f8 37%, #f4f7fb 63%);
  background-size: 400% 100%;
  border-radius: 8px;
  animation: waajo-qr-shimmer 1.4s ease infinite;
}

@keyframes waajo-qr-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.waajo-quickreply-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 22px 10px;
  color: #98a2b3;
  font-size: 10px;
}

.waajo-quickreply-foot {
  padding: 7px 13px;
  color: #98a2b3;
  background: #fbfcfe;
  border-top: 1px solid #eef2f7;
  font-size: 9px;
}

.waajo-quickreply-foot .fa {
  margin-right: 3px;
  color: #c99a55;
}

.waajo-qr-fade-enter-active,
.waajo-qr-fade-leave-active {
  transition: opacity 0.14s ease, transform 0.14s ease;
}

.waajo-qr-fade-enter,
.waajo-qr-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

@media (max-width: 575.98px) {
  .waajo-quickreply-panel {
    position: fixed;
    right: 12px;
    bottom: 76px;
    left: 12px;
    width: auto;
    max-height: 55vh;
  }

  .waajo-quickreply-trigger-copy small {
    max-width: 145px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/omni/components/quickReply.vue